import { render, staticRenderFns } from "./DotsGrid.vue?vue&type=template&id=39d551be"
import script from "./DotsGrid.vue?vue&type=script&lang=js"
export * from "./DotsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports